// extracted by mini-css-extract-plugin
export default {"expandText":"B6j9HIO9yUzLoFrPLTJQ","expandTextContent":"H92dmZo0TpIrDqwMxTND","opened":"GbDFvQx0HZVMFuygS_tz","expandTextButton":"Au89aquifkU2G4YKU_hT"};